import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { TravelReimbursementModel } from "./travel-reimbursement-data.model";

export class AdminTravelReimbursementGridPostParams extends GridPostParams {
}

export class AdminTravelReimbursementGridModel extends TravelReimbursementModel { }

export class AdminTravelReimbursementListingModel extends GridModel<AdminTravelReimbursementGridModel> { }